export default (url) => {
    const urlList = url.split('/').filter(i => i);
    return urlList.map((urlItem, index) => {
        return `/${urlList.slice(0, index + 1).join('/')}`;
    })
};